// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"192":"b704b6b6","6310":"4317fc0c","6555":"184386ee"}[chunkId] + ".chunk.css";
};